// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import moment from 'moment';

// AUT-6432: how a project reads, wherever it is shown. The dashboard presents the same project
// through four surfaces - the landing page's list rows and cards, the map rail's cards and the
// map pin's overview card - and only the layout is allowed to differ between them. Everything
// about the content lives here, so a project cannot say one thing in one view and something
// else in another - a missing date reads "Not set" on every one of them.

// Server dates are UTC; moment.utc keeps a late-evening date from displaying as the day before.
const PROJECT_DATE_FORMAT = 'MMM D, YYYY';

// Shown wherever a project has no value for a field - an order with no delivery date yet, or
// no order at all.
export const PROJECT_VALUE_UNSET = 'Not set';

export const formatProjectDate = (raw?: string | Date | null): string => (
  raw ? moment.utc(raw).format(PROJECT_DATE_FORMAT) : PROJECT_VALUE_UNSET
);
